import ApiClient from "~/admin/services/ApiClient";

export default class CategoriesApi {
  static list = () => ApiClient.get("categories");
  static get = (categoryId) => ApiClient.get(`categories/${categoryId}`);
  static create = (formData, multipart = false) =>
    ApiClient.post("categories", formData, multipart);
  static update = (categoryId, formData, multipart = false) =>
    ApiClient.post(`categories/${categoryId}`, formData, multipart);
}
